module.exports = __webpack_public_path__ + "img/paternoster-04.b71a31fc.jpg";